import React from 'react'
import { useSelector,useDispatch } from 'react-redux'
import { setVigentes } from '../../store/actions/app.actions'

export const VigentesToggle = () => {

  const vigentes  = useSelector(state => state.app.vigentes)


    const dispatch = useDispatch()

//  console.log(vigentes,'trabajadoresVigentestrabajadoresVigentes')


   const changeVigentes = () => {


    dispatch(setVigentes())
    
   }


  return (
    <div className='contenedorTogglesVigentes' >
        <p>Trabajadores vigentes</p>

        <label className="switch">
        <input type="checkbox" checked={vigentes} onChange={() => changeVigentes() } />
        <span className="slider round"></span>
        </label>

    </div>
  )
}
